// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"4556a122","732":"bb769ba1","977":"b03ba452"}[chunkId] + ".chunk.js";
};